import React from "react";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { Link } from "react-router-dom";
import portfolioService from "../../services/portfolioService";



const PortfolioListView = ({ portfolios, onDelete }) => {
    return (
        <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                    <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Portfolio
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Client
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Projects
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Health
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Budget
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Status
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Created
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Actions
                        </th>
                    </tr>
                </thead>

                <tbody className="bg-white divide-y divide-gray-200">
                    {portfolios.map((portfolio) => {
                        const stats = portfolio.stats || {};
                        const budgetUtilization = stats.budget_utilization || 0;
                        const budgetStatusColor = portfolioService.getBudgetStatusColor(budgetUtilization);

                        return (
                            <tr key={portfolio.id} className="hover:bg-gray-50">
                                {/* Portfolio */}
                                <td className="px-6 py-4">
                                <p

                                    className="text-blue-600 hover:text-blue-800 font-medium"
                                >
                                        {portfolio.name}
                                    </p>

                                {/* {portfolio.description && (
                                    <p className="text-sm text-gray-500 mt-1 truncate max-w-md">
                                        {portfolio.description}
                                    </p>
                                )} */}
                                </td>

                                {/* Client */}
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <span className="text-sm text-gray-900">
                                    {portfolio?.owner?.first_name || "N/A"}  {portfolio?.owner?.last_name || "N/A"}
                                    </span>
                                </td>

                                {/* Projects */}
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <span className="text-sm text-gray-900">
                                    {portfolio.stats.total_projects || 0}
                                    </span>
                                </td>

                                <td className="px-6 py-4 whitespace-nowrap">
                                    <span className="text-sm text-gray-900">
                                    {portfolio?.stats?.overall_health || "NA"}
                                    </span>
                                </td>

                                <td className="px-6 py-4 whitespace-nowrap">
                                    {portfolio.budget_allocated > 0 && (
                                        <div className="budget-bar-container">
                                            <div className="budget-bar">
                                                <div
                                                    className="budget-fill"
                                                    style={{
                                                        width: `${Math.min(budgetUtilization, 100)}%`,
                                                        backgroundColor: budgetStatusColor
                                                    }}
                                                />
                                            </div>
                                            <div className="budget-info">
                                                <span>
                                                    {portfolioService.formatBudget(stats.budget_spent || portfolio.budget_spent || 0)} spent
                                                </span>
                                                <span>
                                                    {portfolioService.formatBudget(stats.budget_remaining || 0)} remaining
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </td>

                                {/* Status */}
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <span
                                    className={`px-2 py-1 text-xs font-medium rounded-full ${portfolio.status === "Active"
                                                ? "bg-gray-100 text-green-700"
                                                : "bg-gray-100 text-gray-700"
                                        }`}
                                    >
                                        {portfolio.status || "Active"}
                                    </span>
                                </td>



                                {/* Created Date */}
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    {new Date(portfolio.createdAt).toLocaleDateString()}
                                </td>

                                {/* Actions */}
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                    <Link
                                        to={`/app/portfolios/${portfolio.id}/edit`}
                                        className="text-blue-600 hover:text-blue-900 mr-4"
                                        title="Edit"
                                    >
                                        <i className="fas fa-edit"></i>
                                    </Link>

                                    <button
                                        onClick={() => onDelete(portfolio.id)}
                                        className="text-red-600 hover:text-red-900"
                                    >
                                        <FiTrash2 />
                                    </button>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default PortfolioListView;